import { auth } from "auth"
import { v1, v3 } from "backoffice-api"

export const prefetchImportantData = () => {
  auth.getActiveSession.prefetchQuery()
  v1.getMe.prefetchQuery()
  v1.getCurrentCompany.prefetchQuery()
  v3.getCurrentCompanySettings.prefetchQuery()
}
